import { parse } from 'query-string';
import { useConnect } from '@lore/query-connect';
import TagTypes from '@/constants/TagTypes';
import getQueryUtils, { attributeKeys } from './queryUtils';

export default function useQuery(props) {
  const {
    search = {},
    location = {},
    PAGE_SIZE = 12,
    returnCsvQuery = false
  } = props;

  const queryUtils = getQueryUtils(search, attributeKeys);

  const query = {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfIntentTags',
            relation: 'tagNodes.tag',
            $where: {
              type: TagTypes.Intent
            }
          }
        ],
        $where: {
          $and: [...queryUtils.where]
        },
        $having: {
          numberOfIntentTags: {
            $lte: 0
          }
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    // we do not have a special not educator and not partner format for the CSV, so let's just use educator
    const prescriptive = {
      where: {
        eager: {
          $where: {
            // this will hold the network id if one is applied
          }
        },
        filter: 'unclassified',
        intent: 'educator'
      },
    }
    return prescriptive
  }

  return result;
}
